import { Component, Input } from '@angular/core';
import {BsDropdownDirective} from 'ngx-bootstrap/dropdown';

@Component({
    selector: 'ui-link-items',
    templateUrl: './link-items.component.html',
    styleUrls: ['./link-items.component.less']
})
export class LinkItemsComponent {
    readonly iconCookie = '/assets/img/icons/cookie.svg';
    @Input() dropdown: BsDropdownDirective;

    openCookieSettings(): void {
        // tslint:disable-next-line
        window['Optanon']?.ToggleInfoDisplay();
    }
}
